import { Id, SingleSelectField } from "@dgs/core";
import { ReactNode } from "react";
import { DataFieldIndexResource } from "../../types/dataField";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createSelectFieldDataFieldContactAttributeBaseHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeBaseHandler {
	return {
		type: "SELECT_FIELD_DATA_FIELD",
		id,
		getLabel: () => dataField.label,
	};
}

export function createSelectFieldDataFieldContactAttributeProfileHandler(
	id: Id,
	value: Id | null,
	dataField: DataFieldIndexResource,
): IContactAttributeHandler<Id | null> {
	const baseHandler = createSelectFieldDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return dataField.options.find((o) => o.id === this.value)?.value ?? "";
		},
		renderFormField(t, prefix): ReactNode {
			return (
				<SingleSelectField
					name={`${prefix ? `${prefix}.` : ""}${id}.value`}
					label={baseHandler.getLabel(t)}
					placeholder={dataField.placeholder}
					description={dataField.description}
					options={dataField.options}
					getLabel={(option) => option.value}
					getValue={(option) => option.id}
					clearable={true}
				/>
			);
		},
		toRequestValue(): ContactAttributeRequest<Id | null> {
			return { id, value: this.value };
		},
	};
}

export function createSelectFieldDataFieldContactAttributeListHandler(
	id: Id,
	dataField: DataFieldIndexResource,
): IContactAttributeListHandler {
	const baseHandler = createSelectFieldDataFieldContactAttributeBaseHandler(id, dataField);
	return {
		...baseHandler,
		getColumnSize: () => "max-content",
	};
}
